import React from 'react';
import './disclaimer.scss';

export default function CurrencyDisclaimer() {
    return(
        <div className="currency-disclaimer">
           <span className="bold-text">Disclaimer: </span><span>The following currencies have been rounded off to the nearest thousand for ease of reading: Korean Won, Indonesian Rupiah, & Vietnamese Dong.</span>
        </div>
    )
}